<template>
  <v-btn
    class="mx-1"
    :href="referralLinkStaking"
    target="_blank"
    @click="captureReferralLink('referrallink_howto_insurance', referralLinkStaking); return false;"
    outlined
    small
    ><slot>https://wisetoken.net/staking</slot>
  </v-btn>
</template>

<script>
import config from "@/utils/config.json";

export default {
  name: "ReferralLinkStaking",

  data() {
    return {
      referralAccount: config.referralAccount
    };
  },
  computed: {
    referralLinkStaking() {
      return "https://wisetoken.net/staking/?w=" + config.referralAccount;
    },
  },
  methods: {
    captureReferralLink(category, url) {
      this.$ga.event(category, 'click', url, 1234);
    }
  }
};
</script>
